module.exports = __webpack_public_path__ + "assets/img/Linkstatus.97254b9d.jpg";